export default __webpack_public_path__ + "static/media/1210.b0824335.png";